import React from "react";
import Item from "../../../components/print/workDiary/Item";
import { Typography } from "antd";
import { useIntl } from "react-intl";
const { Title } = Typography;

const CompanyApproval = (props) => {
  const intl = useIntl();
  return (
    <div className="borderedSection">
      <Title level={5}>
        {intl.formatMessage({
          id: "app.work_diary_print.company_approval",
        })}
      </Title>
      <div className="rowContainer">
        <Item name="company_signature" line_type="vertical" />
        <div className="horizontal_spacer" />
        <Item name="date" line_type="vertical" />
      </div>
    </div>
  );
};

export default CompanyApproval;
